document.addEventListener("DOMContentLoaded", function () {
  const detailsItems = document.querySelectorAll('details[is="details-dropdown"]');

  detailsItems.forEach((details) => {
    let timeout;

    details.addEventListener("mouseenter", () => {
      clearTimeout(timeout);
      details.open = true;
    });

    details.addEventListener("mouseleave", () => {
      timeout = setTimeout(() => {
        details.open = false;
      }, 200);
    });

    // Empêche le toggle quand on clique (pour éviter le conflit)
    const summary = details.querySelector("summary");
    if (summary) {
      summary.addEventListener("click", (e) => {
        e.preventDefault();
      });
    }
  });
});
